import { useRef, useState } from "react";
import { Container } from "./styles";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import classNames from "classnames";
import SVG from "react-inlinesvg";
import IconButton from "../../IconButton/index.jsx";

export const EntryMenu = ({ handleDelete, disabled, roleLabel, isSelected, selectedItems, otherActions }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    setVisible(false);
  });

  return (
    <Container className="item-menu">
      <a className="hotdog-dots">
        <IconButton
          onClick={(e) => {
            setVisible(!visible);
          }}
          src="/assets/three-dots.svg"
          disabled={disabled}
          ariaLabel="Open actions menu"
        />
      </a>

      {visible && (
        <div
          className={classNames("custom-field-action-menu", { visible })}
          ref={ref}
        >
          <div className={classNames("custom-field-action-menu__inner")}>
            <div className="actions">
              {!!otherActions && otherActions.map((action) => action)}
              <div
                onClick={handleDelete}
                className={classNames("menu-item", "delete")}
              >
                <div className="icon">
                  <SVG
                    src="/assets/delete.svg"
                    aria-hidden="true"
                  />
                </div>
                <div className="label">{isSelected && selectedItems.length > 1 ? `Delete ${selectedItems.length} items` : "Delete"}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default EntryMenu;
